import React, { createContext, useContext } from "react";

interface IUserDetailsFormContext {
    userId: string;
}

const initialContext: IUserDetailsFormContext = {
    userId: "",
};

const UserDetailsFormContext = createContext(initialContext);

export const UserDetailsFormContextProvider = ({
    userId,
    children,
}: {
    // @dev
    // `userId` denotes unique user id (generated using `user${index + 1}`)
    // so that each user specific field like name, email stc. can be saved.
    //
    // Pass a diff `userId` and wrap it around `GSTDetailsFormGroup` and
    // `UserDetailsFormGroup` components to suuport multiple user booking.
    userId: string;
    children: JSX.Element | JSX.Element[];
}) => {
    return (
        <UserDetailsFormContext.Provider value={{ userId }}>
            {children}
        </UserDetailsFormContext.Provider>
    );
};

export const useUserDetailsFormContext = () => {
    return useContext(UserDetailsFormContext);
};
